import React from 'react';
import { useIntl } from 'react-intl';
import Modal from '~components/modal';
import CompactReviewForm from './CompactReviewForm';
import Loader from '~components/loader';

const ReviewFormModal = ({ 
  isOpened, 
  onToggle, 
  authorId, 
  receiverId, 
  receiverFirstName,
  existingReview,
  isReviewLoading,
  onSubmitSuccess
}) => {
  const intl = useIntl();
  
  return (
    <Modal.Wrapper 
      isOpened={isOpened} 
      onClose={onToggle} 
      className="c-modal--plain c-modal--narrow"
    >
      <Modal.Content>
        <h2 className="l-headline--secondary c-review-modal__headline">
          {intl.formatMessage(
            { id: 'containers.review.headline', defaultMessage: 'Review {firstName}' },
            { firstName: receiverFirstName }
          )}
        </h2>    
        
        {isReviewLoading ? (
            <Loader />
          ) : (
            <CompactReviewForm
              authorId={authorId}
              receiverId={receiverId}
              receiverFirstName={receiverFirstName}
              onSubmitSuccess={onSubmitSuccess || onToggle}
              score={existingReview?.score}
              comment={existingReview?.text}
              reviewId={existingReview?.id}
              action={existingReview ? 'edit' : 'create'}
            />
          )}
      </Modal.Content>
    </Modal.Wrapper>
  );
};

export default ReviewFormModal;